import { IconModule } from './../icon/icon.module';
import { StatusModule } from "../status/status.module";
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CardModule } from "../card/card.module";
import { MultiselectComponent } from "./multiselect.component";
import { CheckboxModule } from "../checkbox/checkbox.module";
import { FormsModule } from "@angular/forms";
@NgModule({
	declarations: [MultiselectComponent],
	imports: [
		CommonModule,
		CardModule,
		CheckboxModule,
		FormsModule,
		HelpTextModule,
		LabelModule,
		StatusModule,
		FormsModule,
		IconModule
	],
	exports: [MultiselectComponent]
})
export class MultiselectModule { }
